import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  .popUpContainer.width-500 {
    width: 100%;
    max-width: 500px;
  }
  article {
    max-height: 800px;
    height: fit-content;
    background-color: hsla(0, 0%, 100%, 0.05);
    backdrop-filter: blur(25px);
    border-radius: 0 0 10px 10px;
    padding: 0 0 0 0;
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 30px 0 0 30px;
  }

  :target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  .subtitle {
    border-top: 1px solid hsla(0, 0%, 100%, 0.15);
    padding-top: 15px;
    margin-top: 15px;
  }
  .subtitle:first-child {
    border-top: 0;
    margin-top: 0;
  }
  .fees_on_profit_wrap ul {
    padding: 0;
    margin: 10px 0 0 45px;
    width: calc(100% - 45px);
  }
  .fees_on_profit_wrap ul:nth-child(5) {
    border-bottom: 0;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/fees_calc.css */
  ul,
  li {
    list-style: disc;
    font-size: 0.8rem;
    line-height: 130%;
  }
  ul {
    margin: 10px 0 0 30px;
    width: 100%;
    padding: 10px 30px 0 15px;
  }
  li {
    margin: 0 0 10px 0;
  }
  li:last-child {
    margin: 0;
  }
  .fees_calc .subtitle {
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
    padding: 15px 0 0 30px;
  }
  .fees_calc p {
    padding: 5px 0 0 30px;
    font-size: 0.8rem;
    line-height: 130%;
  }
  .fees_calc .fees_on_profit_wrap {
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: column;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 600px) {
    article {
      height: 80vh;
      max-height: 80vh;
      overflow: auto;
      flex-direction: column;
    }
  }
`

const developerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/modal.css */
`

export const BidRulesModalCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
